import React from 'react';
import { Button } from 'ui';
import { useIntercomArticle } from 'projects/hooks/useIntercomArticle';

function HelpButton({intercomArticle, children, variant="blue"}) {
  const handleClick = useIntercomArticle(intercomArticle);

  return (
    <Button
      variant={variant}
      onClick={handleClick}
    >
      {children}
    </Button>
  )
}

export default HelpButton;
